/**
 * Canonical event name constants for Mixpanel / analytics.
 * Import from "../analytics" (the public API) — not directly from this file.
 */
export const EVENTS = {
  page_view: "page_view",
  file_uploaded: "file_uploaded",
  edd_generated: "edd_generated",
  edd_previewed: "edd_previewed",
  edd_downloaded: "edd_downloaded",
  ai_feature_used: "ai_feature_used",
  error_encountered: "error_encountered",
  onboarding_step_completed: "onboarding_step_completed",
  config_edited: "config_edited",
} as const;

export type EventName = (typeof EVENTS)[keyof typeof EVENTS];
